// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

// Lazy-loaded Component
const RedeemCashOrCouponsView = lazy(
  () => import('pages/accounting/redeemCashOrCouponsView')
);
const CouponsRoute = (
  <Route
    path={routeName.cashAndCoupons}
    element={
      <PrivateRoute name={resourceName.cashAndCoupons}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <RedeemCashOrCouponsView />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default CouponsRoute;
